import {
  PAGE_SETTED,
  USER_DATA_CHANGED,
  BLOCKCHAIN_SETTED,
  AI_CHECK_WALLET_WELCOME_SETTED,
  AI_FIRST_WELCOME_SETTED,
  AI_TOKEN_ANALYZER_WELCOME_SETTED,
  AI_CHECK_WALLET_ERROR_SETTED,
  AI_CHECK_WALLET_PROCESSING_SETTED,
  AI_NEW_TEXT_SETTED,
  AI_NEW_TEXT_UNSETTED,
  AI_TOKEN_ANALYZER_PROCESSING_SETTED,
  TOKEN_ANALYZER_STATS_PROCESSING,
  TOKEN_ANALYZER_STATS_SETTED,
  CHECK_WALLET_STATS_PROCESSING,
  CHECK_WALLET_STATS_SETTED,
  NOTIFICATION_SHOWED,
  NOTIFICATION_HID
} from "../consts/consts";

export const setPage = (pageType) => {
  return {
    type: PAGE_SETTED,
    payload: pageType
  };
};

export const setAiCheckWalletWelcome = () => {
  return {
    type: AI_CHECK_WALLET_WELCOME_SETTED
  };
};

export const setAiCheckWalletError = () => {
  return {
    type: AI_CHECK_WALLET_ERROR_SETTED
  };
};

export const setAiCheckWalletProcessing = () => {
  return {
    type: AI_CHECK_WALLET_PROCESSING_SETTED
  };
};

export const setAiTokenAnalyzerProcessing = () => {
  return {
    type: AI_TOKEN_ANALYZER_PROCESSING_SETTED
  };
};

export const setAiTokenAnalyzerWelcome = () => {
  return {
    type: AI_TOKEN_ANALYZER_WELCOME_SETTED
  };
};

export const setAiFirstWelcome = () => {
  return {
    type: AI_FIRST_WELCOME_SETTED
  };
};

export const setAiNewText = () => {
  return {
    type: AI_NEW_TEXT_SETTED
  };
};

export const unsetAiNewText = () => {
  return {
    type: AI_NEW_TEXT_UNSETTED
  };
};

export const setCheckWalletStats = (data) => {
  return {
    type: CHECK_WALLET_STATS_SETTED,
    payload: data
  };
};

export const setCheckWalletProcessingStats = () => {
  return {
    type: CHECK_WALLET_STATS_PROCESSING
  };
};

export const setTokenAnalyzerProcessingStats = () => {
  return {
    type: TOKEN_ANALYZER_STATS_PROCESSING
  };
};

export const setTokenAnalyzerStats = (data) => {
  return {
    type: TOKEN_ANALYZER_STATS_SETTED,
    payload: data
  };
};

export const showNotification = (data) => {
  return {
    type: NOTIFICATION_SHOWED,
    payload: data
  };
};


export const hideNotification = () => {
  return {
    type: NOTIFICATION_HID
  };
};

export const changeUserData = (data) => {
  return {
    type: USER_DATA_CHANGED,
    payload: data
  };
};

export const setBlockchain = (blockchain) => {
  return {
    type: BLOCKCHAIN_SETTED,
    blockchain: blockchain
  };
};